const AUTH_KEY = 'gisliberty_demo_auth';
export const DEMO_USERNAME = 'administrator';
export const DEMO_PASSWORD = 'administrator';

export function isDemoAuthenticated() {
  try {
    return sessionStorage.getItem(AUTH_KEY) === '1';
  } catch {
    return false;
  }
}

export function loginDemo(username, password) {
  const ok = username === DEMO_USERNAME && password === DEMO_PASSWORD;
  if (ok) {
    sessionStorage.setItem(AUTH_KEY, '1');
  }
  return ok;
}

export function logoutDemo() {
  sessionStorage.removeItem(AUTH_KEY);
}
